/**
 * UNE HEURE SANS SES SECONDES.
 *
 * ──────────────────────────────────────────────────────────────────────────────────────────
 * POURQUOI CE FICHIER EXISTE. Postgres rend une colonne `time` sous la forme `08:00:00`.
 * Affichée telle quelle, une disponibilité devient « 08:00:00–09:00:00 » : six caractères de
 * bruit par créneau, sur des listes qui en comptent des dizaines, pour une précision qu'aucune
 * disponibilité déclarée au quart d'heure ne porte.
 *
 * ON COUPE LE TEXTE, ON NE REFORMATE PAS. Passer par un objet `Date` ferait réinterpréter
 * l'heure dans le fuseau du navigateur : `new Date("08:00:00")` n'est pas une heure, c'est une
 * date invalide, et les tentatives pour la rendre valide décalent l'heure d'un fuseau.
 *
 * `hhmm` NE S'APPLIQUE QU'À L'AFFICHAGE, jamais au `value` d'un champ de saisie : un
 * `<input type="time">` contrôlé dont on tronque la valeur se battrait avec l'utilisateur à
 * chaque frappe.
 * ──────────────────────────────────────────────────────────────────────────────────────────
 */

/** « 08:00:00 » → « 08:00 ». Rend une chaîne vide plutôt que « null » si la valeur manque. */
export const hhmm = (v) => (v == null ? "" : String(v).trim().slice(0, 5));

/** La même coupe, mais partout dans un texte déjà composé : « Lundi 08:00:00–09:00:00 ». */
export const sansSecondes = (v) =>
  String(v ?? "").replace(/(\d{1,2}:\d{2}):\d{2}/g, "$1");

/** « 08:00 – 09:00 », ou « 08:00 » si la fin manque. Le tiret n'apparaît pas tout seul. */
export const creneau = (debut, fin, separateur = "–") => {
  const d = hhmm(debut), f = hhmm(fin);
  if (!d && !f) return "";
  return f ? `${d}${separateur}${f}` : d;
};

export default hhmm;
